import React from 'react';
import { BrandColor } from '@styleseat/brand';
import { Inline } from '@styleseat/ui';
import { Button } from '../../../ui';
import { CloseIcon } from '../../../ui/Icons';

type InlineLoginModalHeaderProps = {
  onCloseModal: () => void;
  leftSide: React.ReactNode;
};

export const InlineLoginModalHeader: React.FCWithChildren<InlineLoginModalHeaderProps> = ({
  onCloseModal,
  leftSide,
}) => (
  <Inline
    justifyContent="space-between"
    alignItems="center"
    minWidth="100%"
    paddingTop={24}
    paddingX={24}
  >
    {leftSide}
    <Button
      appearance="none"
      onClick={onCloseModal}
      testID="login_signup_modal_close_button"
    >
      <CloseIcon color={BrandColor.Ash} width={20} height={20} />
    </Button>
  </Inline>
);
